import { initializeLanguages } from './translation';
import { initializeLeadForms } from './leadForms';

const testimonials = [
  { text: 'Jos Immigration Law provided clarity and support when our family needed it most. Their guidance made a complicated process easier to understand.', name: 'Maria G.', role: 'Family Immigration Client' },
  { text: 'From the first consultation, I felt heard and respected. They handled my employment visa with incredible attention to detail. Truly exceptional.', name: 'David K.', role: 'Employment Visa Client' },
  { text: 'We were facing deportation and felt hopeless. The team at Jos Immigration Law fought for us and gave our family a second chance in America.', name: 'The Ahmed Family', role: 'Deportation Defense Client' },
];

export function initializePage(root, onAccepted) {
  const listeners = [];
  const on = (element, event, handler, capture = false) => {
    element.addEventListener(event, handler, capture);
    listeners.push(() => element.removeEventListener(event, handler, capture));
  };
  // Submission must be ready before optional reveal, carousel or translation work.
  const stopForms = initializeLeadForms(root, on, onAccepted);
  root.classList.add('jil-js-27');
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('jil-visible-32'); observer.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -60px 0px' }) : null;
  root.querySelectorAll('.jil-reveal-28').forEach(el => observer ? observer.observe(el) : el.classList.add('jil-visible-32'));

  let active = 0;
  const dots = [...root.querySelectorAll('.jil-ts-dot-151')];
  const renderTestimonial = () => {
    const testimonial = testimonials[active];
    root.querySelector('#jil-id-slide-text-200').textContent = `"${testimonial.text}"`;
    root.querySelector('#jil-id-slide-name-201').textContent = testimonial.name;
    root.querySelector('#jil-id-slide-role-202').textContent = testimonial.role;
    const slide = root.querySelector('#jil-id-slide-199');
    slide.classList.remove('jil-slide-in-143');
    void slide.offsetWidth;
    slide.classList.add('jil-slide-in-143');
    dots.forEach((dot, index) => {
      dot.classList.toggle('jil-dot-active-152', index === active);
      dot.setAttribute('aria-current', index === active ? 'true' : 'false');
    });
  };
  on(root.querySelector('#jil-id-next-205'), 'click', () => { active = (active + 1) % testimonials.length; renderTestimonial(); });
  on(root.querySelector('#jil-id-prev-203'), 'click', () => { active = (active + testimonials.length - 1) % testimonials.length; renderTestimonial(); });
  dots.forEach((dot, index) => on(dot, 'click', () => { active = index; renderTestimonial(); }));
  renderTestimonial();

  const stopLanguages = initializeLanguages(root, on);
  if (window.location.hash) {
    const target = document.getElementById(window.location.hash.slice(1));
    if (target && root.contains(target)) target.scrollIntoView();
  }
  return () => {
    listeners.forEach(remove => remove()); observer?.disconnect(); stopForms(); stopLanguages();
  };
}